import "./detials.css"
import { useNavigate } from "react-router-dom";


function OneServices(){
      const navigate = useNavigate();

 
    return(
        <>
        <div className="servicedetials">
            <div className="row">
                <div className="col-md-12">
                   <div className="box">
    <i className="fas fa-dumbbell"></i>
    <h4>Physiotherapy and Rehabilitation Unit</h4>
    <p>
        Relies on advanced therapeutic programs and modern techniques to restore mobility and muscle strength after sports injuries or major surgeries. Sessions are supervised by certified physiotherapists who use electrical stimulation devices and tailored exercises to accelerate recovery and reduce pain, alongside a patient health education program on preventive methods.
    </p>
    <p>April 28, 2025</p>
</div>
                </div>
            </div>
           <div className="row  m-2">
  <div className="buttons">
  
     <button
      className="btn w-100 btn-warning m-2"
      onClick={() => navigate(-1)}
    >
      <i className="fas fa-exclamation-triangle w-100"></i>
      Return to Service
    </button>

  
  </div>
</div>
        </div>
        </>
    )
}
export default OneServices